// extracted by mini-css-extract-plugin
module.exports = {"item":"_2U_cXtRxKsPs3LqUKX9Dmd"};